export const refund = {
    method: 'POST',
    paths: [
        '/api/orgs/:orgId/locations/:locationId/orders/:orderId/transactions/:transactionId/refund',
    ],
    fields: {
        amount: {
            type: 'price',
            required: true,
            displayName: 'refund amount',
            // "Cannot refund less than a penny"
        },
    },
};
//# sourceMappingURL=transactions_refund.js.map